<template>
  <div>
    <c-search-box @enter="getList">
      <template slot="search">
        <div class="col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2">
          <!-- 사업장 -->
          <c-plant type="search" name="plantCd" v-model="searchParam.plantCd" />
        </div>
        <div class="col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2">
          <c-select :comboItems="useFlagItems" type="search" itemText="codeName" itemValue="code" name="existFlag" label="유해위험성 포함여부" v-model="searchParam.existFlag"></c-select>
        </div>
      </template>
    </c-search-box>
    <c-table ref="table" title="화학자재 유해위험성 목록" :columns="grid.columns" :data="grid.data" @linkClick="linkClick">
      <!-- 버튼 영역 -->
      <template slot="table-button">
        <q-btn-group outline>
          <q-icon name="help_outline" size="24px" color="grey-8" class="cursor-pointer q-mr-md">
            <q-popup-proxy>
              <c-table title="유해위험성 구분 범례" :columns="gridClass.columns" :data="gridClass.data" :gridHeight="gridClass.height" hideBottom> </c-table>
            </q-popup-proxy>
          </q-icon>
          <c-btn label="LBLSEARCH" icon="search" @btnClicked="getList" />
        </q-btn-group>
      </template>
    </c-table>
    <c-dialog :param="popupOptions"></c-dialog>
  </div>
</template>

<script>
import selectConfig from '@/js/selectConfig';
export default {
  name: 'chemHarmfulRisk',
  data() {
    return {
      searchParam: {
        plantCd: null,
        useFlag: 'Y',
        existFlag: null,
        mdmChemMaterialId: null,
      },
      useFlagItems: [
        { code: 'Y', codeName: '유해위험성 포함' },
        { code: 'N', codeName: '유해위험성 미포함' },
      ],
      grid: {
        columns: [
          {
            fix: true,
            name: 'plantName',
            field: 'plantName',
            label: '사업장명',
            align: 'center',
            style: 'width:100px',
            sortable: true,
          },
          {
            fix: true,
            name: 'materialCd',
            field: 'materialCd',
            label: '자재코드',
            align: 'center',
            style: 'width:100px',
            sortable: true,
          },
          {
            fix: true,
            name: 'materialName',
            field: 'materialName',
            label: '화학자재명',
            align: 'left',
            type: 'link',
            style: 'width:200px',
            sortable: true,
          },
          {
            name: 'propertiesStateName',
            field: 'propertiesStateName',
            label: '성상',
            align: 'center',
            style: 'width:60px',
            sortable: true,
          },
          {
            name: 'usageName',
            field: 'usageName',
            label: '용도',
            align: 'center',
            style: 'width:90px',
            sortable: true,
          },
          {
            name: 'harmfulRisk',
            field: 'harmfulRisk',
            label: '유해성·위험성',
            child: [],
          },
        ],
        data: [],
      },
      gridClass: {
        columns: [
          {
            fix: true,
            name: 'harmfulRiskClassName',
            field: 'harmfulRiskClassName',
            label: '유해위험성구분',
            align: 'center',
            style: 'width:130px',
            sortable: true,
          },
          {
            name: 'gubun1',
            field: 'gubun1',
            label: '구분1',
            align: 'left',
            style: 'width:250px',
            sortable: true,
            type: 'html',
          },
          {
            name: 'gubun1a',
            field: 'gubun1a',
            label: '구분1A',
            align: 'left',
            style: 'width:250px',
            sortable: true,
            type: 'html',
          },
          {
            name: 'gubun1b',
            field: 'gubun1b',
            label: '구분1B',
            align: 'left',
            style: 'width:250px',
            sortable: true,
            type: 'html',
          },
          {
            name: 'gubun1c',
            field: 'gubun1c',
            label: '구분1C',
            align: 'left',
            style: 'width:250px',
            sortable: true,
            type: 'html',
          },
          {
            name: 'gubun2',
            field: 'gubun2',
            label: '구분2',
            align: 'left',
            style: 'width:250px',
            sortable: true,
            type: 'html',
          },
          {
            name: 'gubun2a',
            field: 'gubun2a',
            label: '구분2A',
            align: 'left',
            style: 'width:250px',
            sortable: true,
            type: 'html',
          },
          {
            name: 'gubun2b',
            field: 'gubun2b',
            label: '구분2B',
            align: 'left',
            style: 'width:250px',
            sortable: true,
            type: 'html',
          },
          {
            name: 'gubun3',
            field: 'gubun3',
            label: '구분',
            align: 'left',
            style: 'width:250px',
            sortable: true,
            type: 'html',
          },
          {
            name: 'gubun4',
            field: 'gubun4',
            label: '구분',
            align: 'left',
            style: 'width:250px',
            sortable: true,
            type: 'html',
          },
          {
            name: 'gubun5',
            field: 'gubun5',
            label: '구분',
            align: 'left',
            style: 'width:250px',
            sortable: true,
            type: 'html',
          },
        ],
        data: [],
        height: '500px',
      },
      editable: true,
      listUrl: '',
      listLegendUrl: '',
      popupOptions: {
        isFull: true,
        target: null,
        title: '',
        visible: false,
        top: '',
        param: {},
        closeCallback: null,
      },
    };
  },
  beforeCreate() {},
  created() {},
  beforeMount() {},
  mounted() {
    this.init();
  },
  beforeDestroy() {},
  methods: {
    init() {
      // role setting
      this.editable = this.$route.meta.editable;
      // url setting
      this.listUrl = selectConfig.mdm.mam.chem.harmfulList.url;
      this.listLegendUrl = selectConfig.mdm.mam.chem.harmfulLegendList.url;
      // code setting
      // list setting
      this.setDynamicColumns();
      this.getLegend();
    },
    setDynamicColumns() {
      this.$comm.getComboItems('HARMFUL_RISK_CLASS_CD').then(_result => {
        const dynamicChildren = [];
        const items = _result.filter(x => x.useFlag == 'Y');
        this.$_.forEach(items, item => {
          dynamicChildren.push({
            name: item.code,
            field: item.code,
            label: item.codeName,
            align: 'center',
            style: 'width:100px',
            sortable: true,
            type: 'html',
          });
        });
        const harmfulRiskColumn = this.grid.columns.find(col => col.name === 'harmfulRisk');
        if (harmfulRiskColumn) harmfulRiskColumn.child = dynamicChildren;
        this.getList();
      });
    },
    getList() {
      this.$http.url = this.listUrl;
      this.$http.type = 'GET';
      this.$http.param = this.searchParam;
      this.$http.request(_result => {
        this.grid.data = _result.data;
      });
    },
    getLegend() {
      this.$http.url = this.listLegendUrl;
      this.$http.type = 'GET';
      this.$http.request(_result => {
        this.gridClass.data = _result.data;
      });
    },
    linkClick(row) {
      this.openPop(row);
    },
    openPop(row) {
      this.popupOptions.title = '화학자재 상세';
      this.popupOptions.param = {
        mdmChemMaterialId: row ? row.mdmChemMaterialId : '',
        plantCd: row ? row.plantCd : '',
        tabName: 'chemGhs',
      };
      this.popupOptions.target = () => import(`${'@/pages/mdm/mam/chemDetail.vue'}`);
      this.popupOptions.visible = true;
      this.popupOptions.isFull = true;
      this.popupOptions.closeCallback = this.closePopup;
    },
    closePopup() {
      this.popupOptions.target = null;
      this.popupOptions.visible = false;
      this.getList();
    },
  },
};
</script>
